<template>
  <!-- 物料管理 -->
  <div class="wrapper">
    <div class="searchconditions">
      <el-form :model="listForm" ref="listForm" inline>
        <el-form-item prop="companyName" label="企业名称">
          <el-input
            v-model="listForm.companyName"
            placeholder="请输入名称"
            maxlength="50"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" type="cyan" @click="searchList"
            >查询</el-button
          >
          <el-button icon="el-icon-refresh" type="warning" @click="reset"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <el-row :gutter="10">
      <el-col :span="1.5" class="add-btn">
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd"
          >新增包材厂</el-button
        >
      </el-col>
    </el-row>
    <el-table :data="list" v-loading="loading" border>
      <el-table-column
        type="index"
        label="序号"
        width="80"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="companyName"
        label="企业名称"
        min-width="120"
        align="center"
      >
        <!-- <template slot-scope="scope">
          <span
            style="cursor: pointer; color: #409eff"
            @click="rowDetail(scope.row)"
            >{{ scope.row.companyName }}</span
          >
        </template> -->
      </el-table-column>
      <el-table-column
        prop="contactPerson"
        label="联系人"
        align="center"
        min-width="100"
      ></el-table-column>
      <el-table-column
        prop="contactPhone"
        label="联系电话"
        align="center"
        min-width="100"
      ></el-table-column>
      <el-table-column
        prop="userName"
        label="超管账号"
        align="center"
        min-width="100"
      ></el-table-column>
      <el-table-column
        prop="status"
        label="登录状态"
        align="center"
        min-width="100"
      >
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            active-color="#13ce66"
            :active-value="1"
            :inactive-value="0"
            @change="statusChange(scope.row)"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column
        prop="updateUser"
        label="最后操作人"
        align="center"
        min-width="100"
      ></el-table-column>
      <el-table-column
        prop="updateTime"
        label="最后操作时间"
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">
          {{ scope.row.updateTime}}
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        min-width="150"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            icon="el-icon-edit"
            @click="handleEdit(scope.row)"
            >编辑</el-button
          >
          <el-button
            type="primary"
            size="mini"
            icon="el-icon-edit"
            @click="handlePwd(scope.row)"
            >重置密码</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="prev, pager, next, sizes, total, jumper"
      :page-sizes="[10, 15, 20]"
      :page-size="listForm.pageSize"
      :total="total"
      :current-page="listForm.pageNum"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    >
    </el-pagination>
    <el-dialog
      :title="title"
      :visible.sync="dialogEdit"
      :close-on-click-modal="false"
      width="800px"
      @close="dialogEditClose"
    >
      <el-form
        ref="editForm"
        :model="editForm"
        :rules="editRule"
        label-width="150px"
      >
        <div class="audit-line">基本信息</div>
        <el-row>
          <el-col :span="16">
            <el-form-item label="企业名称" prop="companyName">
              <el-input
                v-model="editForm.companyName"
                placeholder="请输入企业名称"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="16">
            <el-form-item label="联系人" prop="contactPerson">
              <el-input
                v-model="editForm.contactPerson"
                placeholder="请输入联系人"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="16">
            <el-form-item label="联系人手机号" prop="contactPhone">
              <el-input
                v-model="editForm.contactPhone"
                placeholder="请输入手机号"
                @blur="setAccount"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="address">
              <div class="address-city">
                <el-form-item label="企业地址：" prop="companyAddress">
                  <el-cascader
                    ref="province"
                    :options="options"
                    v-model="companyAddress"
                    expand-trigger="click"
                    filterable
                  >
                  </el-cascader>
                </el-form-item>
              </div>
              <div class="address-detail">
                <el-form-item prop="address">
                  <el-input
                    v-model="editForm.address"
                    placeholder="详细地址"
                    maxlength="50"
                  ></el-input>
                </el-form-item>
              </div>
            </div>
          </el-col>
        </el-row>
        <div class="audit-line">
          企业配置<span style="color: #f56c6c; margin-left: 10px">(必填)</span>
        </div>
        <el-row>
          <el-col :span="12">
            <el-form-item label="登录账号（超管）" prop="userName">
              <el-input
                v-model="editForm.userName"
                placeholder="请输入手机号"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="初始登录密码">
              <el-input
                disabled
                placeholder="联系人手机号后六位"
                v-model="editForm.productBrandCode"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogEdit = false">取 消</el-button>
        <el-button type="primary" @click="saveAddOrEdit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  queryPlasticCompany,
  addPlasticCompany,
  editPlasticCompany,
  companyUpdateStatus,
  resetPwd,
} from "@/common/api.js";
import options from "@/common/province.json";
export default {
  props: {},
  data() {
    return {
      options: options,
      loading: false,
      listForm: {
        pageNum: 1,
        pageSize: 10,
        companyName: "",
      },
      total: 0,
      list: [],
      title: "新增",
      dialogEdit: false,
      companyAddress: [],
      editForm: {
        companyId: "",
        companyName: "", //名称
        contactPerson: "",
        contactPhone: "",
        provCode: "",
        cityCode: "",
        areaCode: "",
        address: "",
        userName: "",
        companyUsers: {},
      },
      editRule: {
        companyName: [
          { required: true, validator: this.testCompany, trigger: "blur" },
        ],
        contactPerson: [
          { required: true, validator: this.testPerson, trigger: "blur" },
        ],
        contactPhone: [
          { required: true, validator: this.testPhone, trigger: "change" },
        ],
        userName: [
          { required: true, validator: this.testUserName, trigger: "change" },
        ],
      },
    };
  },
  methods: {
    // 列表
    getPageList() {
      var params = this.listForm;
      this.loading = true;
      queryPlasticCompany(params).then((res) => {
        this.loading = false;
        if (res.errorCode == 200) {
          this.list = res.data.list;
          this.total = res.data.total;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 新增
    handleAdd() {
      this.title = "新增";
      this.dialogEdit = true;
    },
    // 保存
    saveAddOrEdit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.editForm.provCode = this.companyAddress[0];
          this.editForm.cityCode = this.companyAddress[1];
          this.editForm.areaCode = this.companyAddress[2];
          var params = this.editForm;
          console.log(this.editForm);
          if (this.editForm.companyId) {
            editPlasticCompany(params).then((res) => {
              if (res.errorCode == 200) {
                this.$message({
                  type: "success",
                  message: "保存成功",
                });
                this.dialogEdit = false;
                this.getPageList();
                console.log(res);
              } else {
                this.$message.error(res.msg);
              }
            });
          } else {
            addPlasticCompany(params).then((res) => {
              if (res.errorCode == 200) {
                this.$message({
                  type: "success",
                  message: "保存成功",
                });
                this.dialogEdit = false;
                this.getPageList();
                console.log(res);
              } else {
                this.$message.error(res.msg);
              }
            });
          }
        }
      });
    },
    setAccount() {
      this.editForm.userName = this.editForm.contactPhone;
    },
    handleEdit(row) {
      this.dialogEdit = true;
      this.title = "编辑";
      this.editForm = {
        companyId: row.companyId,
        companyName: row.companyName,
        contactPerson: row.contactPerson,
        contactPhone: row.contactPhone,
        address: row.address,
        provCode: row.provCode,
        cityCode: row.cityCode,
        areaCode: row.areaCode,
        userName: row.userName,
        companyUsers: {},
      };
      this.companyAddress = [row.provCode, row.cityCode, row.areaCode];
    },
    // 查看详情
    // rowDetail(row) {
    //   console.log(row);
    //   this.dialogDetail = true;
    //   var params = {
    //     productId: row.productId,
    //   };
    //   productDetail(params).then((res) => {
    //     console.log(res);
    //     if (res.errorCode == 200) {
    //       this.$nextTick(() => {
    //         this.detailForm = {
    //           productionProductTypeId: res.product.productionProductTypeId, //产品类型
    //           productName: res.product.productName, //产品名称
    //           productCode: res.product.productCode, //产品编号
    //           packingRatio: res.product.packingRatio, //包装比例
    //           specifications: res.product.specifications,
    //           remark: row.remark,
    //           propertyDeploy: res.propertyDeployList,
    //         };
    //       });
    //     } else {
    //       this.$message.error(res.msg);
    //     }
    //   });
    // },
    //详情窗口关闭
    // handleDetailClose() {
    //   this.detailForm = {
    //     productionProductTypeId: null,
    //     productName: "",
    //     productCode: "",
    //     packingRatio: "",
    //     specifications: "",
    //     propertyDeploy: [],
    //     remark: "",
    //   };
    // },
    handlePwd(row) {
      const h = this.$createElement;
      let name = row.companyName;
      this.$msgbox({
        title: "提示",
        message: h("p", null, [
          h("h3", { style: "margin-bottom: 10px" }, name),
          h(
            "h3",
            { style: "margin-bottom: 10px" },
            "请确认是否重置该工厂的超管登录密码?"
          ),
          h("h3", { style: "margin-bottom: 10px" }, "重置后密码：000000"),
        ]),
        showCancelButton: true,
        closeOnClickModal:false,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            done();
            var params = {
              companyId: row.companyId,
              pwd: "000000",
            };
            resetPwd(params).then((res) => {
              if (res.errorCode == 200) {
                this.$message({
                  type: "success",
                  message: "操作成功",
                });
              } else {
                this.$message.error(res.msg);
              }
            });
          } else {
            done();
          }
        },
      })
        .then((action) => {
          console.log("确定");
        })
        .catch(() => {
          console.log("取消");
        });
    },
    //修改状态
    statusChange(row) {
      const h = this.$createElement;
      let text = row.companyName;
      if (row.status == 1) {
        text = "启用";
      } else if (row.status == 0) {
        text = "禁用";
      }
      this.$msgbox({
        title: "提示",
        message: h("p", null, [
          h("h3", null, '是否将 "' + text + '" 该企业?', "警告"),
        ]),
        showCancelButton: true,
        closeOnClickModal:false,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            done();
            var params = {
              companyId: row.companyId,
              status: row.status,
            };
            companyUpdateStatus(params).then((res) => {
              if (res.errorCode == 200) {
                this.$message({
                  type: "success",
                  message: "操作成功",
                });
              } else {
                this.$message.error(res.msg);
                if (row.status == 1) {
                  row.status = 0;
                } else if (row.status == 0) {
                  row.status = 1;
                }
              }
            });
          } else {
            done();
            if (row.status == 1) {
              row.status = 0;
            } else if (row.status == 0) {
              row.status = 1;
            }
          }
        },
      })
        .then((action) => {
          console.log("确定");
        })
        .catch(() => {
          console.log("取消");
        });
    },

    // 查询
    searchList() {
      this.listForm.pageNum=1;
      this.getPageList();
    },
    // 搜索框重置
    reset() {
      this.$nextTick(() => {
        this.$refs["listForm"].resetFields();
        this.listForm = {
          pageNum: 1,
          pageSize: 10,
          companyName: "",
        };
        this.getPageList();
      });
    },
    dialogEditClose() {
      this.$nextTick(() => {
        this.editForm = {
          companyId: "",
          companyName: "", //名称
          contactPerson: "",
          contactPhone: "",
          provCode: "",
          cityCode: "",
          areaCode: "",
          address: "",
          userName: "",
          companyUsers: {},
        };
        this.companyAddress = [];
        this.$refs["editForm"].resetFields();
      });
    },
    testCompany(rule, value, callback) {
      if (value) {
        if (value.length > 20) {
          callback(new Error("最多输入20个字符"));
        }
        var str = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\ \/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/;
        if (value.match(str)) {
          callback(new Error("不能输入特殊字符"));
        }
        callback();
      } else {
        callback(new Error("请输入企业名称"));
      }
    },
    testPerson(rule, value, callback) {
      if (value) {
        if (value.length > 10) {
          callback(new Error("最多输入10个字符"));
        }
        var str = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\ \/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/;
        if (value.match(str)) {
          callback(new Error("不能输入特殊字符"));
        }
        callback();
      } else {
        callback(new Error("请输入联系人"));
      }
    },
    testPhone(rule, value, callback) {
      if (value) {
        var checkRule = /^1[3456789]\d{9}$/;
        var mobile = checkRule.test(value);
        if (!mobile) {
          callback(new Error("手机号码格式不正确，请重新输入"));
        }
        callback();
      } else {
        callback(new Error("请输入手机号"));
      }
    },
    testUserName(rule, value, callback) {
      if (value) {
        var str = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\ \/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/;
        if (value.match(str)) {
          callback(new Error("不能输入特殊字符"));
        }
        callback();
      } else {
        callback(new Error("请输入超管帐号"));
      }
    },
    handleCurrentChange(cpage) {
      this.listForm.pageNum = cpage;
      this.getPageList();
    },
    handleSizeChange(psize) {
      this.listForm.pageSize = psize;
      this.getPageList();
    },
  },
  mounted() {
    this.getPageList();
  },
};
</script>
<style lang="less" scoped>
.wrapper {
  width: 100%;
  height: 100%;
  .title {
    padding: 0 50px;
    .search {
      float: right;
    }
  }
  .searchconditions {
    width: calc(100% - 30px);
    background: #fff;
    border-radius: 6px;
    margin-top: 10px;
    padding: 20px 15px;
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
    .el-form {
      .el-form-item {
        display: inline-block;
        margin-right: 10px;
        vertical-align: top;
        margin: 5px 15px 5px 0px;
        /deep/.el-button {
          padding: 8px 15px;
          font-size: 12px;
          border-radius: 3px;
        }
      }
    }
  }
  /deep/.el-message-box__message h3 {
    margin-bottom: 10px !important;
  }
  .dialog-button {
    padding: 8px 15px;
    font-size: 12px;
    border-radius: 3px;
    margin-bottom: 15px;
  }
  .label-line {
    border-left: 3px solid #409eff;
    font-size: 16px;
    padding-left: 10px;
    font-weight: bold;
  }
  .avatar-uploader {
    /deep/.el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .el-upload:hover {
      border-color: #409eff;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 120px;
      height: 120px;
      line-height: 120px;
      text-align: center;
    }
    .avatar {
      width: 120px;
      height: 120px;
      display: block;
    }
  }
  .audit-line {
    font-size: 15px;
    font-weight: bold;
    margin-left: 20px;
    margin-bottom: 15px;
  }
  .el-row {
    margin: 10px 0 0 !important ;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    background-color: #ffffff;
    padding: 5px 15px 0;
    .add-btn {
      float: left;
      padding: 0;
      margin-top: 5px;
      margin-bottom: 10px;
      .el-button {
        padding: 8px 15px;
        font-size: 12px;
        border-radius: 3px;
      }
    }
    .btn-group-right {
      float: right;
      .el-button {
        padding: 8px;
      }
    }
    .btn-group-right {
      margin-top: 5px;
      span {
        display: inline-block;
        vertical-align: top;
        font-size: 20px;
        padding: 8px;
      }
    }
    .standard-code {
      font-size: 14px;
      color: #8f8f8f;
      display: inline-block;
      line-height: 40px;
      margin-left: 10px;
    }
    .el-select {
      width: 100%;
    }
    .expiry-date /deep/.el-form-item__content {
      margin-left: 10px !important;
    }
  }
  .address {
    display: flex;
    justify-content: space-between;
    .el-cascader {
      width: 100%;
    }
    .address-city {
      width: 56%;
    }
    .address-detail {
      width: 40%;
      margin-right: 2%;
      /deep/.el-form-item__content {
        margin-left: 0 !important;
      }
    }
  }
  /deep/.vue-treeselect__control {
    height: 40px;
    line-height: 40px;
  }
  /deep/.vue-treeselect__placeholder,
  /deep/.vue-treeselect__single-value {
    line-height: 40px;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/system/businessManage/plasticAccountManage.vue